import { render, staticRenderFns } from "./RedHospitalariaView.vue?vue&type=template&id=f3873c40&scoped=true"
import script from "./RedHospitalariaView.vue?vue&type=script&lang=js"
export * from "./RedHospitalariaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3873c40",
  null
  
)

export default component.exports